import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import { ColombiaAds } from "../ads/colombia-ads/index";

import "./colombia-ads.m.css";

export class ColombiaAdBase extends React.Component {
  constructor() {
    super();
    this.state = {
      renderMobileColombiaAds: false,
      colombiaAdIdsForHome: {
        en: {
          mobile: "312802",
          desktop: "312788"
        },
        hi: {
          mobile: "312806",
          desktop: "312792"
        },
        ur: {
          mobile: "312810",
          desktop: "312797"
        }
      },
      colombiaAdIdsForStoryPage: {
        en: {
          mobile: "312804",
          desktop: "312790"
        },
        hi: {
          mobile: "312808",
          desktop: "312795"
        },
        ur: {
          mobile: "312809",
          desktop: "312800"
        }
      },

      styles: {
        float: "left",
        minHeight: "2px",
        width: "100%"
      }
    };
  }

  getTargetingDevice() {
    return this.state.renderMobileColombiaAds ? "m" : "d";
  }
  colombiaObj = (containerId, slot, position, section, ua, inlineStyle) => {
    return {
      containerId: containerId,
      slot: slot,
      position: position,
      section: section,
      ua: ua,
      inlineStyle: inlineStyle
    };
  };

  getRequiredColombiaId(obj) {
    const getLang = this.props.publisherAttributes["lang"];
    return this.state.renderMobileColombiaAds ? obj[getLang]["mobile"] : obj[getLang]["desktop"];
  }

  getColombiaAds(pageType) {
    let colombiaId;
    if (pageType === "home-page") {
      colombiaId = this.getRequiredColombiaId(this.state.colombiaAdIdsForHome);
    }
    if (pageType === "story-page" || pageType === "story-preview") {
      colombiaId = this.getRequiredColombiaId(this.state.colombiaAdIdsForStoryPage);
    }
    return this.colombiaObj(
      `div-clmb-ctn-${colombiaId}-1`,
      `${colombiaId}`,
      "1",
      "0",
      this.getTargetingDevice(),
      this.state.styles
    );
  }

  componentDidMount() {
    if (document.documentElement.clientWidth < 768) {
      this.setState({ renderMobileColombiaAds: true });
    }
  }
  render() {
    const { pageType } = this.props;

    const colombiaProps = () => {
      if (pageType["pageType"] === "home-page") {
        return this.getColombiaAds(pageType["pageType"]);
      } else if (pageType["pageType"] === "story-page" || pageType["pageType"] === "story-preview") {
        return this.getColombiaAds(pageType["pageType"]);
      }
    };

    return (
      <div className="colombia-ads-story">
        <ColombiaAds data={colombiaProps()} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"]),
    pageType: get(state, ["qt"])
  };
}

export const ColombiaAdWrapper = connect(
  mapStateToProps,
  null
)(ColombiaAdBase);

ColombiaAdBase.propTypes = {
  publisherAttributes: PropTypes.object,
  pageType: PropTypes.object
};
